import { useState } from 'react'
import { useRequest } from 'ahooks'
import { getUserProfileApi, postProfileAvatarApi, postProfileApi, putUpdatePasswordApi } from 'api'
import { BoundarySlice } from 'redux/reducers'
import { useDispatch } from 'react-redux'

export const useProfileRequest = () => {
    const dispatch = useDispatch()
    const [userProfile, setUserProfile] = useState()

    // 获取用户个人资料
    const { run: getUserProfile, loading } = useRequest(params => getUserProfileApi(), {
        manual: true,
        onSuccess: data => {
            setUserProfile(data.data)
        },
        onError: error => dispatch(BoundarySlice.actions.addError(error)),
    })

    // 提交用户头像
    const { runAsync: postProfileAvatar } = useRequest(file => postProfileAvatarApi(file), {
        manual: true,
        onError: error => dispatch(BoundarySlice.actions.addError(error)),
    })

    // 提交用户个人资料
    const { runAsync: postProfile } = useRequest(params => postProfileApi(params), {
        manual: true,
        onError: error => dispatch(BoundarySlice.actions.addError(error)),
    })

    // 修改用户密码
    const { runAsync: putUpdatePassword } = useRequest(params => putUpdatePasswordApi(params), {
        manual: true,
        onError: error => dispatch(BoundarySlice.actions.addError(error)),
    })

    return {
        loading,
        userProfile,
        getUserProfile,
        postProfileAvatar,
        postProfile,
        putUpdatePassword
    }
}
